"use client"

import { useState } from "react"
import styles from "./DisputeModal.module.css"

const DisputeModal = ({ shift, onClose, onSubmit }) => {
  const [selectedCategory, setSelectedCategory] = useState("")
  const [comment, setComment] = useState("")

  const disputeCategories = [
    "Shift Not Performed",
    "Unauthorized Shift Extension",
    "Late Arrival",
    "Performance Issue",
    "Last-Minute Cancellation",
    "Missing Attendance Entry",
    "Other",
  ]

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!selectedCategory) {
      alert("Please select a dispute category")
      return
    }

    if (selectedCategory === "Other" && !comment.trim()) {
      alert("Please provide a comment for the dispute")
      return
    }

    onSubmit(selectedCategory, comment)
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.disputeModal}>
        <div className={styles.modalHeader}>
          <h2>Dispute Shift</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.modalBody}>
          <form onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label>Dispute Category *</label>
              <div className={styles.categoryOptions}>
                {disputeCategories.map((category) => (
                  <label key={category} className={styles.categoryOption}>
                    <input
                      type="radio"
                      name="category"
                      value={category}
                      checked={selectedCategory === category}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                    />
                    <span>{category}</span>
                  </label>
                ))}
              </div>
            </div>

            {selectedCategory === "Other" && (
              <div className={styles.formGroup}>
                <label htmlFor="comment">Comment *</label>
                <textarea
                  id="comment"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Please describe the issue..."
                  rows="4"
                  required
                />
              </div>
            )}

            <div className={styles.modalActions}>
              <button type="button" className={styles.cancelBtn} onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className={styles.submitBtn}>
                Submit Dispute
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default DisputeModal
